var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logosSliderSection",class:{
    'logosSliderSection--white': _vm.data.WhiteBackground,
  }},[_c('div',{staticClass:"container"},[_c('SectionContainer',{attrs:{"title":_vm.data.Title,"small-center-title":_vm.data.SmallCenterTitle}},[_c('div',{staticClass:"logosSliderSection__content"},[_c('SliderLogotypes',{attrs:{"items":_vm.items,"size":_vm.slideSize}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }